import { useState, useEffect } from "react";
import { useWindowScroll } from "react-use";
const Scroll = () => {
  const [scrolled, setScrolled] = useState(0);
  const { x, y } = useWindowScroll();
  useEffect(() => {
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    setScrolled((y / height) * 100);
  }, [y]);
  return (
    <div className="fixed h-[3px] top-0 left-0 right-0 w-full z-10">
      <div
        className="bg-teal-600 dark:bg-teal-300 h-full"
        style={{ width: `${scrolled}%` }}
      ></div>
    </div>
  );
};

export default Scroll;
